export default __webpack_public_path__ + "static/Blue_Gem_(Aberration)-92f857240248b215aa0b51773ecea085.png";